import { ButtonProps } from "@mui/material";

export enum DataImportFieldType {
  String = "string",
  Number = "number",
  Email = "email",
  Boolean = "boolean",
  Date = "date",
}

export enum DataImportStatus {
  Idle = "idle",
  Parsing = "parsing",
  Ready = "ready",
  Invalid = "invalid",
}

export interface IDataImportField {
  key: string;
  label: string;
  required?: boolean;
  fieldType?: DataImportFieldType;
  aliases?: string[];
  validate?: (value: unknown, row: Record<string, unknown>) => string | null;
}

export interface DataImportColumnMapping {
  fieldKey: string;
  csvHeaders: string[];
  confidence: number;
  matchedBy: string;
}

export interface DataImportCellError {
  rowIndex: number;
  fieldKey: string;
  fieldLabel: string;
  message: string;
  value?: unknown;
}

export interface DataImportParsedResult<TEntity> {
  rows: TEntity[];
  rawRows: Record<string, unknown>[];
  mappings: DataImportColumnMapping[];
  errors: DataImportCellError[];
}

export interface DataImportProps<TEntity extends Record<string, unknown>> {
  entityName: string;
  fields: IDataImportField[];
  maxPreviewRows?: number;
  allowPartialImport?: boolean;
  onConfirm: (data: TEntity[]) => void;
  isLoading?: boolean;
  onReset?: () => void;
  transformRow?: (row: Record<string, unknown>) => TEntity;
}

export interface ColumnMappingModalTriggerProps extends Omit<ButtonProps, "color" | "variant"> {
  entityName: string;
  mappings: DataImportColumnMapping[];
  errorsCount: number;
  requiredFieldsWithoutMappingCount: number;
  hasManualMappedColumns: boolean;
  hasMappingProblems: boolean;
}

export interface AutoMappingResult {
  csvHeaders: string[];
  confidence: number;
  matchedBy: string;
}
